import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";

const Miniwidget = (props) => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Row>
        {props.reports.map((report, key) => (
          <Col sm={6} key={key}>
            <Card
              className="mini-stat cursor-pointer"
              onClick={() => report.link && navigate(report.link)}
              style={{
                cursor: report.link ? "pointer" : "default",
              }}
            >
              <CardBody className="card-body d-flex gap-4">
                <div className="mini-stat-icon bg-primary">
                  <i className="float-start mdi mdi-chart-line"></i>
                </div>

                <div>
                  <h2 className="mb-1 font-size-24">{report.total}</h2>

                  <h6
                    className="mb-1 font-size-12"
                    style={{ color: "#6B6B6B" }}
                  >
                    {report.title}
                  </h6>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );
};

export default Miniwidget;
